import { type RootState } from "../../../../Application/globaltypes/redux";

export const videosStateSelector = (state: RootState) => state.library.videos;
